<template>
    <div v-for="(favCampaign, index) in favCampaigns"
        :key="favCampaign.id"
        class="menu-wrapper mx-4 lg:mx-0 py-6 flex text-14 lg:text-16"
        :class="[index+1 == favCampaigns.length ? '' : 'border-b border-a-brown-d7c7b8']">
        <img class="w-135px lg:w-190px max-h-90px lg:max-h-130px rounded-10" :src="favCampaign.fullImageUrl">
        <div class="pl-3 w-full flex flex-col justify-between lg:justify-start">
            <div class="flex justify-between lg:mb-4">
                <div class="text-a-brown-502314 pr-3.5 flex-1">{{favCampaign.name}}</div>
                <div class="w-22px" @click="clickFavorite(favCampaign.id)">
                    <img src="@/assets/icon/ic-fav-active.svg" />
                </div>
            </div>
            <div class="text-a-red-d62300 lg:mb-4">{{favCampaign.pricePerUnit}} {{lbl.favorite.thb}}</div>
            <div class="flex justify-between">
                <div class="meat-group flex items-center">
                    <div v-for=" meat in getMeatType(favCampaign)" :key="meat.name_en">
                        <img class="mr-3 w-7 lg:w-10 object-contain" :src="meat.image_url">
                    </div>
                </div>
                <RedButton customClass="min-w-min h-fit px-3 py-1"
                        @click="clickOrderNow(favCampaign.id)">{{lbl.favorite.btn_order_now}}
                </RedButton>
            </div>
        </div>
    </div>
</template>
<script>
// component
import RedButton from '@/components/Button/RedButton.vue';
// mixins
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from '@/mixin/ModalMixin';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
// service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign';
export default {
    name: "MenuList",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        RedButton,
    },
    data: function() {
        return {
            favCampaigns: null,
            isLoaded: false,
        }
    },
    created: function() {
        this.getFavoriteCampaign();
    },
    methods: {
        getFavoriteCampaign: function(){
            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                BzbsCampaign.apiGetFavouriteList().subscribe({
                    next: (campaigns) => {
                        setTimeout(()=>{
                            this.modal.loadingModal.hide();
                        },100)
                        this.favCampaigns = campaigns;
                        this.isLoaded = true;
                        resolve(true);
                    },
                    error: (err) => {
                        this.isLoaded = true;
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        getMeatType: function(favCampaigns){
            if(!favCampaigns.extra) return;
            const objExtra= JSON.parse(favCampaigns.extra);
            return objExtra.detail;
        },
        clickFavorite: function(campaignId){
            if(!campaignId) return;

             this.tracking.event('favorite','click favorite list', `favorite| ${campaignId}`);

            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                BzbsCampaign.apiRemoveFavourite(campaignId).subscribe({
                    next: () => {
                        setTimeout(()=>{
                            this.modal.loadingModal.hide();
                        },100)
                        this.getFavoriteCampaign();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        clickOrderNow: function(campaignId){
            this.$router.push('/product/'+campaignId);
        },
    },

}
</script>
<style lang="scss" scoped>
</style>
